//import sortedIcon from "../../assets/images/png/sortedIcon.png";
//import unsortedIcon from "../../assets/images/png/upDown.png";
import grayInfoIcon from "../../assets/images/svg/grayInfoIcon.svg";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Modal from "../Modal";
import ArrowButton from "../ArrowButton/index";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
} from "../Accordion/Accordion";
import { observer } from "mobx-react";
import { allocationColorsStatic, homePageRoute } from "../../utils/constants";
import {
  commaSeperated,
  // getDisplayDate,
  getLimitPer,
  numWithUnit,
  showDashIfZero,
  showPercentageDash,
} from "../../utils/functions";
import UserStore from "../../store/UserStore";
import AuthStore from "../../store/AuthStore";
import TableCaption from "../TableCaption/TableCaption";
import EmptyDataText from "../EmptyDataText/EmptyDataText";

const AccordionTable = observer(
  ({
    setIsNavigated,
    setOthersModalOpen,
    othersModalOpen,
    tooltipModalOpen,
    setToolTipModalOpen,
    dataPoint,
    isOffshore = false,
    currency = {
      currency: "",
    },
    tab = 0,
    page = "",
    tableCaption = "",
    isAccordionContentTableCaption = false,
    AccordionContentTableCaptionSuffix = "",
  }) => {
    // const [filteredColumn, setFilteredColumn] = useState("");
    const [openAccordions, setOpenAccordions] = useState({});
    const [headerColumn, setHeaderColumn] = useState([]);
    const [contentColumn, setContentColumn] = useState([]);

    const location = useLocation();
    const navigate = useNavigate();
    const { instrumentId } = useParams();

    const assetClassTableData =
      tab === 1 && !isOffshore
        ? UserStore.familyViewData
        : tab === 1 && isOffshore
          ? UserStore[dataPoint]?.familyViewData
          : UserStore.isInfinity === "0"
            ? UserStore[dataPoint]?.clientAssetClass
            : UserStore?.portfolio?.clientAssetClassInfinity;

    useEffect(() => {
      if (UserStore.isInfinity !== "1") {
        if (location.state?.open) {
          setOpenAccordions((prevState) => {
            return {
              ...prevState,
              [UserStore.selectedRefId
                ? UserStore.portfolioOpenID
                : "a" || location.state.open]: true,
            };
          });
        } else {
          setOpenAccordions((prevState) => {
            return {
              ...prevState,
              [UserStore.selectedRefId ? UserStore.portfolioOpenID : "a"]: true,
            };
          });
        }
      } else {
        if (location.state?.open2) {
          setOpenAccordions((prevState) => {
            return {
              ...prevState,
              [UserStore.infinityOpenID || location.state.open2]: true,
            };
          });
        } else {
          setOpenAccordions((prevState) => {
            return {
              ...prevState,
              [UserStore.infinityOpenID]: true,
            };
          });
        }
      }
    }, [location]);

    const OthersModalContent = () => {
      const handleCloseOthersModal = () => {
        setOthersModalOpen(false);
        setToolTipModalOpen(false);
      };

      if (othersModalOpen) {
        return (
          <div className="others_content_wrapper">
            <p>
              Others is a sum of unaccounted difference in the valuation that
              can arise due to one of the below reasons:
            </p>
            <div className="others_list_items">
              <p>1. Instrument held outside Infinity folio are not included</p>
              <p>2. Valuation method variation</p>
              <p>3. Price upload delays</p>
              <p>
                4. Newly created/bought instruments may take some time to
                reflect
              </p>
            </div>
            <div className="got_it_button">
              <ArrowButton
                type="next"
                label="Okay, Got it"
                onClick={handleCloseOthersModal}
              />
            </div>
          </div>
        );
      } else if (tooltipModalOpen) {
        return (
          <div className="others_content_wrapper">
            <p>
              Current Value will differ from Infinity portal due to one of the
              following reasons:
            </p>
            <div className="others_list_items">
              <p>1. Valuation method variation</p>
              <p>2. Valuation upload delays</p>
              <p>
                3. Newly created/bought instruments may take some time to
                reflect
              </p>
            </div>
            <div className="got_it_button">
              <ArrowButton
                type="next"
                label="Okay, Got it"
                onClick={handleCloseOthersModal}
              />
            </div>
          </div>
        );
      }
    };

    const investedValueCellRenderer = (data, key) => {
      switch (key) {
        case "current_value":
          return (
            <>
              <p className="invested_value_cell">
                <p className="invested_value_cell font-roboto">
                  {UserStore.isHybridNormalInstrument
                    ? numWithUnit(
                        data.investmentreturn.current_value.value,
                        data.investmentreturn.current_value.value_type,
                        true,
                      )
                    : numWithUnit(
                        data.investmentreturn.current_value.value,
                        data.investmentreturn.current_value.value_type,
                      )}
                </p>

                <p className="as_on_date hide_text">As on</p>
              </p>
            </>
          );
        case "assetClass":
          return (
            <p className="invested_value_cell">
              {data?.assetClass?.name || "-"}
            </p>
          );
        case "invested_value":
          return (
            <p
              className="invested_value_cell font-roboto"
              style={{
                visibility: data.id !== 0 ? "visible" : "hidden",
              }}
            >
              {UserStore.isHybridNormalInstrument
                ? numWithUnit(
                    data.investmentreturn.invested_value.value,
                    data.investmentreturn.invested_value.value_type,
                    true,
                  )
                : numWithUnit(
                    data.investmentreturn.invested_value.value,
                    data.investmentreturn.invested_value.value_type,
                  )}
            </p>
          );
        case "realised_gain":
          return (
            <p
              className="invested_value_cell font-roboto"
              style={{
                visibility: data.id !== 0 ? "visible" : "hidden",
              }}
            >
              {UserStore.isHybridNormalInstrument
                ? numWithUnit(
                    data.investmentreturn.realised_gain.amount.value,
                    data.investmentreturn.realised_gain.amount.value_type,
                    true,
                  )
                : numWithUnit(
                    data.investmentreturn.realised_gain.amount.value,
                    data.investmentreturn.realised_gain.amount.value_type,
                  )}
            </p>
          );
        case "int_div":
          return (
            <p
              className="invested_value_cell font-roboto"
              style={{
                visibility: data.id !== 0 ? "visible" : "hidden",
              }}
            >
              {UserStore.isHybridNormalInstrument
                ? numWithUnit(
                    data.investmentreturn.int_div?.amount.value,
                    data.investmentreturn.int_div?.amount.value_type,
                    true,
                  )
                : numWithUnit(
                    data.investmentreturn.int_div?.amount.value,
                    data.investmentreturn.int_div?.amount.value_type,
                  )}
            </p>
          );
        case "unrealised_gain":
          return (
            <p
              className="invested_value_cell font-roboto"
              style={{
                visibility: data.id !== 0 ? "visible" : "hidden",
              }}
            >
              <span className="no_clr">
                <span className="sr-only">Unrealised Gain</span>
                {UserStore.isHybridNormalInstrument
                  ? numWithUnit(
                      data.investmentreturn.unrealised_gain?.amount.value,
                      data.investmentreturn.unrealised_gain?.amount.value_type,
                      true,
                    )
                  : numWithUnit(
                      data.investmentreturn.unrealised_gain?.amount.value,
                      data.investmentreturn.unrealised_gain?.amount.value_type,
                    )}
              </span>
              &nbsp;&nbsp;
              {!!data?.investmentreturn.unrealised_gain?.percentage &&
              Number(data?.investmentreturn.unrealised_gain?.percentage) < 0 ? (
                <>
                  <span className="sr-only">Decreased By</span>
                  <span className="negative">
                    {UserStore.isHybridNormalInstrument
                      ? getDash(
                          getLimitPer(
                            data?.investmentreturn.unrealised_gain?.percentage,
                          ),
                          "perc",
                        )
                      : data?.investmentreturn.unrealised_gain?.percentage !==
                          null
                        ? getLimitPer(
                            data?.investmentreturn.unrealised_gain?.percentage,
                          ) + "%"
                        : "0".concat("%")}
                  </span>
                </>
              ) : (
                <>
                  <span className="sr-only">Increased By</span>
                  <span className="positive">
                    {UserStore.isHybridNormalInstrument
                      ? getDash(
                          getLimitPer(
                            data?.investmentreturn.unrealised_gain?.percentage,
                          ),
                          "perc",
                        )
                      : data?.investmentreturn.unrealised_gain?.percentage !==
                          null
                        ? getLimitPer(
                            data?.investmentreturn.unrealised_gain?.percentage,
                          ) + "%"
                        : "0".concat("%")}
                  </span>
                </>
              )}
            </p>
          );
        case "irr":
          return (
            <p
              className="invested_value_cell font-roboto"
              style={{
                visibility: data.id !== 0 ? "visible" : "hidden",
              }}
            >
              {!!data?.investmentreturn?.irr &&
              Number(data?.investmentreturn?.irr) < 0 ? (
                <span className="negativeIrr">
                  {UserStore.isHybridNormalInstrument
                    ? showPercentageDash(
                        getLimitPer(data?.investmentreturn?.irr),
                      )
                    : getLimitPer(data?.investmentreturn?.irr) + "%"}
                </span>
              ) : (
                <span className="positiveIrr">
                  {" "}
                  {UserStore.isHybridNormalInstrument
                    ? showPercentageDash(
                        getLimitPer(data?.investmentreturn?.irr),
                      )
                    : getLimitPer(data?.investmentreturn?.irr) + "%"}{" "}
                </span>
              )}
            </p>
          );
        default:
          return <p className="invested_value_cell">{data[key]}</p>;
      }
    };

    const allocationCellRenderer = (data, key, rowData) => {
      return (
        <div
          className="allocation_cell allocation-bar"
          style={{
            paddingTop: `20px`,
            paddingLeft: "0px",
            paddingRight: "0",
            justifyContent: "end",
          }}
        >
          <div className="allocation_cell_content">
            <div
              className="progress_bar_container"
              style={{
                position: "relative",
              }}
            >
              <div className="progress_text_wrapper">
                <span className="allocation_text">Allocation </span>
                <span className={`progress_percentage ${data[key]}`}>
                  {data[key]}%
                </span>
              </div>

              <div className="progress_sub_asset_class">
                <div
                  className="progress_value_div"
                  style={{
                    backgroundColor:
                      allocationColorsStatic[rowData?.assetClass?.id] ||
                      allocationColorsStatic[data?.assetClass?.id],
                    width: data[key] + "%",
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      );
    };

    const redirectCellRender = (data, key, rowData) => {
      return (
        <div className="allocation_cell">
          <div className="allocation_cell_content">
            <button
              style={{
                textAlign: "center",
              }}
              onClick={() => {
                AuthStore.updateLoadingFullScreen(true);

                const currentPage = location?.pathname?.includes("portfolio")
                  ? "portfolio"
                  : homePageRoute;

                const navigationState = {
                  state: {
                    from: `${currentPage}`,
                    title:
                      UserStore.isInfinity === "1"
                        ? `Infinity Holdings ${data?.assetClass?.name}`
                        : data?.assetClass?.name,
                  },
                };

                if (UserStore.isInfinity === "1") {
                  UserStore.setInfinityNRemeberedMeasureId(
                    UserStore.forThirdLevelMeasureId,
                  );
                  navigate(
                    `/${currentPage}/${
                      location?.pathname?.includes("_portfolio")
                        ? "subassetclassdetailsinfiniity_portfolio"
                        : "subassetclassdetailsinfiniity"
                    }/${rowData.id}/${data.id}/${instrumentId}`,
                    navigationState,
                  );
                } else {
                  const subAssetRoute = `/${currentPage}/subassetclassdetails_portfolio/${rowData.id}/${data.id}`;
                  const offshoreRoute = `global-sub-asset-class/${rowData.id}/${data.id}`;
                  const currencyData = currency;
                  if (!isOffshore) {
                    navigate(subAssetRoute, navigationState);
                  } else {
                    AuthStore.updateLoadingFullScreen(false);

                    navigate(offshoreRoute, {
                      state: {
                        from: `${currentPage}`,
                        currency: currencyData.currency,
                        title:
                          UserStore.isInfinity === "1"
                            ? `Infinity Holdings ${data?.assetClass?.name}`
                            : data?.assetClass?.name,
                      },
                    });
                  }
                }
              }}
              className="accordion_right_btn portfolio_button_animation buttonBlueBorder"
            >
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%",
                }}
              >
                <svg
                  width="8"
                  height="12"
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.93394 5.64683L5.28634 6L4.93394 6.35317L0.706721 10.5896L1.41 11.2929L6.70289 6L1.41 0.707108L0.706722 1.41039L4.93394 5.64683Z"
                    fill="white"
                    stroke="#404040"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      );
    };

    const columns = [
      {
        label: "Sub Asset Class",
        key: "assetClass",
        cellRenderer: investedValueCellRenderer,
      },
      {
        label: "Invested Value",
        key: "invested_value",
        cellRenderer: investedValueCellRenderer,
      },
      {
        label: "Current Value",
        key: "current_value",
        cellRenderer: investedValueCellRenderer,
      },

      {
        label: "Int/Div",
        key: "int_div",
        cellRenderer: investedValueCellRenderer,
      },
      {
        label: "Unrealised Gains (%)",
        key: "unrealised_gain",
        cellRenderer: investedValueCellRenderer,
        ariaLabel: "Unrealised Gains With (%)",
      },
      {
        label: "Realised Gain",
        key: "realised_gain",
        cellRenderer: investedValueCellRenderer,
      },
      {
        label: "IRR",
        key: "irr",
        cellRenderer: investedValueCellRenderer,
      },
      {
        label: "Allocation (%)",
        key: "allocation_percentage",
        cellRenderer: allocationCellRenderer,
      },
      {
        label: "Action",
        cellRenderer: redirectCellRender,
        classn: "content-action-button-portfolio",
        headerPosition: { textAlign: "start" },
      },
    ];

    const accordionTableHeaderData = [
      {
        title: "Asset Class",
        sortable: false,
      },
      {
        title: "Allocation (%)",
        sortable: false,
      },
      {
        title: "Inv Value",
        sortable: false,
      },
      {
        title: "Current Value",
        sortable: false,
      },

      {
        title: "Unrealised Gains (%)",
        sortable: false,
        ariaLabel: "Unrealised Gains With (%)",
      },
      {
        title: "Realised Gain",
        sortable: false,
      },
      {
        title: "IRR (Since Inception)",
        sortable: false,
      },
      {
        title: "Action",
        sortable: false,
      },
    ];

    // const handleFilter = (filterType) => {
    //   setFilteredColumn(filterType);
    //   if (filterType === filteredColumn) {
    //     setFilteredColumn("");
    //   }
    // };

    const handleAccordion = (accoridonName, accordionContent) => {
      setOpenAccordions({ ...openAccordions, [accoridonName.id]: true });
      if (openAccordions[accoridonName.id])
        setOpenAccordions({ ...openAccordions, [accoridonName.id]: false });
    };

    const headerRenderer = (
      { label, key, classn, width, headerPosition = {} },
      index,
      arr,
    ) => {
      return (
        <th
          style={{
            width: width,
            textAlign:
              label === "Unrealised Gains (%)"
                ? "center"
                : index
                  ? "end"
                  : "start",
            padding:
              arr.length - 1 === index ? "20px 0px 20px 0px" : "20px  0px",
            paddingLeft: index ? "" : "12px",
            ...headerPosition,
          }}
          className={classn && classn}
        >
          {label}
        </th>
      );
    };

    const getDash = (value, type) => {
      if (!isNaN(value)) {
        if (type === "perc") {
          return (
            showDashIfZero(value) + (showDashIfZero(value) === "-" ? "" : "%")
          );
        } else
          return showDashIfZero(value) === "-" ? "-" : commaSeperated(value);
      } else {
        return value;
      }
    };

    useEffect(() => {
      return () => {
        if (UserStore.isInfinity === "1") UserStore.setIsNavigated(false);
      };
    }, []);

    useEffect(() => {
      if (tab === 0) {
        setHeaderColumn(accordionTableHeaderData);
        setContentColumn(columns);
      } else {
        const familySubColumns = [...columns];
        familySubColumns[8].cellRenderer = () => {
          return (
            <div
              style={{
                borderBottom: "none",
              }}
            ></div>
          );
        };
        familySubColumns[0].label = "Asset Class";
        familySubColumns[8].label = "";
        const accordionTableHeaderDataFamily = [...accordionTableHeaderData];

        accordionTableHeaderDataFamily[0].title = "Family Member";

        setHeaderColumn(accordionTableHeaderDataFamily);
        setContentColumn(familySubColumns);
      }
    }, [tab]);

    return (
      <>
        <table className="accordion_table alignPortfolio">
          <TableCaption captionName={tableCaption} />
          <thead className="accordion_table_header table-header">
            <tr className="accordion-table-header-row">
              {headerColumn?.map((header) => (
                <th
                  scope="col"
                  className="accordion_table_header_child"
                  style={{ width: header.width }}
                  // onClick={() => handleFilter(header.title)}
                >
                  <p className="accordion_table_header_child_heading blueTextColor">
                    {header.title}
                  </p>
                  {/* {header.sortable && (
                <div className="accordion_table_header_child_icon">
                  <img
                    src={
                      filteredColumn === header.title
                        ? sortedIcon
                        : unsortedIcon
                    }
                    alt="sort"
                  />
                </div>
              )} */}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="accordion_table_data">
            {assetClassTableData?.map((rowData, index) => (
              <>
                <Accordion>
                  <AccordionHeader
                    open={openAccordions[rowData.assetClass.id]}
                    clickFun={() =>
                      rowData.assetClass.name !== "Others" &&
                      rowData.assetClass.name !== "Cash" &&
                      handleAccordion(
                        rowData.assetClass,
                        rowData.accordionContent,
                      )
                    }
                    activeClass="accordion_open"
                    inactiveClass="accordion_close"
                    isHeaderPointer={
                      rowData.assetClass.name !== "Others" &&
                      rowData.assetClass.name !== "Cash"
                    }
                  >
                    <>
                      <td className="accordion_table_data_row_td">
                        <span className="asset_class_wrapper">
                          <span
                            className={`color_box ${rowData.assetColor} ${
                              tab === 1 ? "fam_vw_no_color" : ""
                            }`}
                            style={{
                              background: allocationColorsStatic[rowData.id],
                            }}
                          ></span>
                          <span className="asset_class_text">
                            {rowData.assetClass.name}
                          </span>
                        </span>
                        {rowData.assetClass.name === "Others" ? (
                          <div
                            className="info_icon2"
                            onClick={() => setOthersModalOpen(true)}
                          >
                            <img src={grayInfoIcon} alt="arrow" />
                          </div>
                        ) : null}
                      </td>
                      <td className="accordion_table_data_row_td">
                        <div className="progress_bar_container">
                          <div className="progress_text_wrapper">
                            {rowData.assetClass.name === "Others" ? (
                              <EmptyDataText text="No Data" />
                            ) : (
                              <span
                                className={`progress_percentage ${rowData.assetColor}`}
                                style={{
                                  color: allocationColorsStatic[rowData.id],
                                }}
                              >
                                {UserStore.isHybridNormalInstrument
                                  ? getDash(
                                      commaSeperated(
                                        rowData.allocation_percentage,
                                      ),
                                      "perc",
                                    )
                                  : commaSeperated(
                                      rowData.allocation_percentage,
                                    ) + "%"}
                              </span>
                            )}
                          </div>
                          {rowData.assetClass.name !== "Others" ? (
                            <>
                              <>
                                <div className="progress_asset_class">
                                  <div
                                    className="progress_value_div"
                                    style={{
                                      backgroundColor:
                                        allocationColorsStatic[rowData.id] ||
                                        allocationColorsStatic[2],
                                      width:
                                        rowData.allocation_percentage + "%",
                                    }}
                                  ></div>
                                </div>
                              </>
                            </>
                          ) : (
                            <div
                              style={{ width: "100%", paddingRight: "10px" }}
                            ></div>
                          )}
                        </div>
                      </td>
                      <td className="accordion_table_data_row_td">
                        <span className="current_value_wrapper">
                          {(rowData.assetClass.name === "Cash" ||
                            rowData.assetClass.name === "Others") && (
                            <EmptyDataText text="No Data" />
                          )}
                          {rowData.assetClass.name !== "Cash" &&
                            rowData.assetClass.name !== "Others" && (
                              <span className="current_value_text">
                                {rowData.assetClass.name === "Cash"
                                  ? ""
                                  : UserStore.isHybridNormalInstrument
                                    ? numWithUnit(
                                        rowData.investmentreturn.invested_value
                                          .value,
                                        rowData.investmentreturn.invested_value
                                          .value_type,
                                        true,
                                      )
                                    : rowData.assetClass.name !== "Others"
                                      ? numWithUnit(
                                          rowData.investmentreturn
                                            .invested_value.value,
                                          rowData.investmentreturn
                                            .invested_value.value_type,
                                        )
                                      : rowData.assetClass.name === "Others"
                                        ? numWithUnit(
                                            rowData.investmentreturn
                                              .invested_value.value,
                                            rowData.investmentreturn
                                              .invested_value.value_type,
                                          )
                                        : rowData.assetClass.name === "Cash"
                                          ? ""
                                          : ""}
                              </span>
                            )}
                        </span>
                      </td>
                      <td className="accordion_table_data_row_td">
                        <span className="current_value_wrapper">
                          <span
                            className="current_value_text"
                            style={
                              rowData.assetClass.name === "Others"
                                ? { width: "max-content" }
                                : {}
                            }
                          >
                            {(rowData.assetClass.name === "Cash" ||
                              (UserStore.isHybridNormalInstrument &&
                                rowData.assetClass.name !== "Others")) &&
                              numWithUnit(
                                rowData.investmentreturn.current_value.value,
                                rowData.investmentreturn.current_value
                                  .value_type,
                                true,
                              )}
                            {rowData.assetClass.name === "Others" &&
                              "₹ " +
                                commaSeperated(
                                  rowData.investmentreturn.current_value
                                    .actual_value,
                                )}
                            {rowData.assetClass.name !== "Cash" &&
                              !UserStore.isHybridNormalInstrument &&
                              rowData.assetClass.name !== "Others" &&
                              numWithUnit(
                                rowData.investmentreturn.current_value.value,
                                rowData.investmentreturn.current_value
                                  .value_type,
                              )}
                          </span>
                          {/* <p></p> */}
                        </span>
                      </td>

                      <td className="accordion_table_data_row_td">
                        <span
                          className="current_value_wrapper"
                          style={{ position: "relative" }}
                        >
                          {rowData.assetClass.name === "Others" ||
                            (rowData.assetClass.name === "Cash" && (
                              <EmptyDataText text="No Data" />
                            ))}{" "}
                          {rowData.assetClass.name !== "Others" &&
                            rowData.assetClass.name !== "Cash" && (
                              <span className="current_value_text">
                                <span>
                                  <span className="sr-only">
                                    Unrealised Gain
                                  </span>
                                  {rowData.assetClass.name === "Cash"
                                    ? ""
                                    : UserStore.isHybridNormalInstrument
                                      ? numWithUnit(
                                          rowData.investmentreturn
                                            .unrealised_gain?.amount.value,
                                          rowData.investmentreturn
                                            .unrealised_gain?.amount.value_type,
                                          true,
                                        )
                                      : numWithUnit(
                                          rowData.investmentreturn
                                            .unrealised_gain?.amount.value,
                                          rowData.investmentreturn
                                            .unrealised_gain?.amount.value_type,
                                        )}
                                </span>
                                &nbsp;
                                <span className="current_value_sub_text unreal_percentage">
                                  {!!rowData?.investmentreturn.unrealised_gain
                                    ?.percentage &&
                                  Number(
                                    rowData?.investmentreturn.unrealised_gain
                                      ?.percentage,
                                  ) < 0 ? (
                                    <>
                                      <span className="sr-only">
                                        Decreased By
                                      </span>
                                      <span className="negativeUnreal">
                                        {UserStore.isHybridNormalInstrument
                                          ? getDash(
                                              getLimitPer(
                                                rowData?.investmentreturn
                                                  .unrealised_gain?.percentage,
                                              ),
                                              "perc",
                                            )
                                          : rowData.assetClass.name === "Cash"
                                            ? ""
                                            : getLimitPer(
                                                rowData?.investmentreturn
                                                  ?.unrealised_gain?.percentage,
                                              ) + "%"}
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <span className="sr-only">
                                        Increased By
                                      </span>
                                      <span className="positiveUnreal">
                                        {rowData.assetClass.name === "Cash" ||
                                        UserStore.isHybridNormalInstrument
                                          ? getDash(
                                              getLimitPer(
                                                rowData?.investmentreturn
                                                  .unrealised_gain?.percentage,
                                              ),
                                              "perc",
                                            )
                                          : getLimitPer(
                                              rowData?.investmentreturn
                                                ?.unrealised_gain?.percentage,
                                            ) + "%"}
                                      </span>
                                    </>
                                  )}
                                </span>
                              </span>
                            )}
                        </span>
                      </td>
                      <td className="accordion_table_data_row_td">
                        <span
                          className="current_value_wrapper"
                          style={{ position: "relative" }}
                        >
                          {rowData.assetClass.name === "Others" ||
                            (rowData.assetClass.name === "Cash" && (
                              <EmptyDataText text="No Data" />
                            ))}
                          {rowData.assetClass.name !== "Others" &&
                            rowData.assetClass.name !== "Cash" && (
                              <span className="current_value_text">
                                {rowData.assetClass.name === "Cash"
                                  ? ""
                                  : UserStore.isHybridNormalInstrument
                                    ? numWithUnit(
                                        rowData.investmentreturn?.realised_gain
                                          ?.amount?.value,
                                        rowData.investmentreturn?.realised_gain
                                          ?.amount?.value_type,
                                        true,
                                      )
                                    : numWithUnit(
                                        rowData.investmentreturn?.realised_gain
                                          ?.amount?.value,
                                        rowData.investmentreturn?.realised_gain
                                          ?.amount?.value_type,
                                      )}
                              </span>
                            )}
                        </span>
                      </td>
                      <td className="accordion_table_data_row_td">
                        <span
                          className="current_value_wrapper"
                          style={{ position: "relative" }}
                        >
                          {rowData.assetClass.name === "Others" ||
                            (rowData.assetClass.name === "Cash" && (
                              <EmptyDataText text={"No Data"} />
                            ))}{" "}
                          {rowData.assetClass.name !== "Others" &&
                            rowData.assetClass.name !== "Cash" && (
                              <span className="current_value_text">
                                <span
                                  className={
                                    !rowData.investmentreturn.irr?.includes("-")
                                      ? "current_value_sub_text positIrr"
                                      : "current_value_sub_text negatIrr"
                                  }
                                >
                                  {rowData.assetClass.name === "Cash"
                                    ? ""
                                    : UserStore.isHybridNormalInstrument
                                      ? getDash(
                                          getLimitPer(
                                            rowData.investmentreturn.irr,
                                          ),
                                          "perc",
                                        )
                                      : Number(
                                            rowData.investmentreturn.irr,
                                          ).toFixed() !== 0
                                        ? getLimitPer(
                                            rowData.investmentreturn.irr,
                                          ) + "%"
                                        : ""}
                                </span>
                              </span>
                            )}
                        </span>
                      </td>
                      <td className="accordion_table_data_row_td">
                        {(rowData.assetClass.name === "Others" ||
                          rowData.assetClass.name === "Cash" ||
                          (rowData.assetClass === "Cash" &&
                            location?.pathname.includes("infinity"))) && (
                          <EmptyDataText text="No Data" />
                        )}
                        {rowData.assetClass.name !== "Others" &&
                          rowData.assetClass.name !== "Cash" && (
                            <button
                              className="accordion_down_btn portfolio_button_animation buttonBlueBorder"
                              onClick={() =>
                                handleAccordion(
                                  rowData.assetClass,
                                  rowData.accordionContent,
                                )
                              }
                              aria-expanded={
                                openAccordions[rowData.assetClass.id]
                              }
                              aria-controls={rowData.assetClass.name}
                              id={`${rowData.assetClass.name}-data`}
                            >
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: "100%",
                                  width: "100%",
                                }}
                              >
                                {openAccordions[rowData.assetClass.id] ? (
                                  <svg
                                    width="13"
                                    height="8"
                                    viewBox="0 0 13 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.05629 2.77309L6.70312 2.42069L6.34996 2.77309L2.11351 7.00031L1.41023 6.29703L6.70312 1.00414L11.996 6.29703L11.2927 7.00031L7.05629 2.77309Z"
                                      stroke="#404040"
                                    />
                                  </svg>
                                ) : (
                                  <svg
                                    width="13"
                                    height="8"
                                    viewBox="0 0 13 8"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M7.05629 5.23081L6.70312 5.58321L6.34996 5.23081L2.11351 1.0036L1.41023 1.70687L6.70312 6.99977L11.996 1.70688L11.2927 1.0036L7.05629 5.23081Z"
                                      stroke="#404040"
                                    />
                                  </svg>
                                )}
                              </span>
                            </button>
                          )}
                      </td>
                    </>
                  </AccordionHeader>
                  <tr className="accordion-content-data-wrapper">
                    <td colSpan={9} className="accordion-content-wrapper">
                      <AccordionContent
                        open={openAccordions[rowData.assetClass.id]}
                        id={rowData.assetClass.name}
                        role="region"
                        ariaLabelledBy={`${rowData.assetClass.name}-data`}
                      >
                        <table className="table accordion_content_custom_table">
                          {isAccordionContentTableCaption ? (
                            <TableCaption
                              captionName={`${rowData.assetClass.name} ${AccordionContentTableCaptionSuffix}`}
                            />
                          ) : (
                            ""
                          )}
                          <thead>
                            <tr>{contentColumn?.map(headerRenderer)}</tr>
                          </thead>
                          <tbody>
                            {rowData.instrumentVehiclesList?.map(
                              (eachVehicle, index) => {
                                return (
                                  <tr key={index} id={eachVehicle.id}>
                                    {contentColumn.map((eachColumn, index) => {
                                      return (
                                        <td
                                          style={{
                                            textAlign: index ? "end" : "start",
                                          }}
                                        >
                                          {eachColumn.cellRenderer
                                            ? eachColumn.cellRenderer(
                                                eachVehicle,
                                                eachColumn.key,
                                                rowData,
                                              )
                                            : JSON.stringify(
                                                eachVehicle[eachColumn.key],
                                              )}
                                        </td>
                                      );
                                    })}
                                  </tr>
                                );
                              },
                            )}
                          </tbody>
                        </table>
                      </AccordionContent>
                    </td>
                  </tr>
                </Accordion>
              </>
            ))}{" "}
          </tbody>
        </table>
        <Modal
          onClose={() => {
            setOthersModalOpen(false);
            setToolTipModalOpen(false);
          }}
          open={othersModalOpen || tooltipModalOpen}
          title={tooltipModalOpen ? "Current Value" : "Others"}
          width={"861px"}
          showCloseIcon={false}
        >
          <OthersModalContent />
        </Modal>
      </>
    );
  },
);

export default AccordionTable;
